<template>
  <select v-model="$i18n.locale" class="form-control">
    <option v-for="(locale, i) in locales" :key="`locale-${i}`" :value="locale">
      {{ locale == "es" ? $t("spanish") : $t("english") }}
    </option>
  </select>
</template>

<script>
export default {
  name: "Language",
  data() {
    return { locales: ["es", "en"] };
  },
};
</script>
